import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    makeLoginTemp,
} from './../actions/AuthActions';
import {
    resetTeamData,
} from './../actions/ManageTeamActions';
import NextBtn from './onboarding/NextBtn';

class Login extends Component {
    oLoginTap = () => {
        let userToken = window.uefaGHComponent.getUserTokens();
        const isAnonymous = userToken.registered === false;
        userToken = (isAnonymous ? userToken.anonymous : userToken.registered);
        let obj = {
            UefaSocialId: document.getElementById('social_id').value,
            UserId      : document.getElementById('social_id').value,
            ClientId    : 1,
            optType     : 1,
            SocialId    : document.getElementById('social_id').value,
            FullName    : 'Test',
            ProfilePic  : '',
            IsAnonymous : false,
            PlatformId  : '1',
            access_token: userToken.access_token
        };
        this.props.makeLogin(obj).then(() => {
            const loginResponse = this.props.loginResponse;
            if (loginResponse && loginResponse.Meta['Success'] && loginResponse.Meta['RetVal'] === 1) {
                // this.props.resetTeamData();
                alert('Login successful :)');
            } else {
                alert('Login failed :(');
            }
        });
    };

    render() {
        const style = {textAlign: 'center'};
        return (<div>
            <br/>
            <br/>
            <div style={style}><input type="tel" placeholder="Enter Social ID" id="social_id"/></div>
            <br/>
            <br/>
            <div className="si-btn-wrp" ref={(ref) => this.nextBtn = ref}>
                <NextBtn text={this.props.trans['login_to_continue']}
                         showTitle={true} tooltipText={this.props.trans['login_to_continue']}
                         handler={() => this.oLoginTap()}/>
            </div>
            <br/>
            <br/>
        </div>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        makeLogin    : (data) => dispatch(makeLoginTemp(data)),
        resetTeamData: () => dispatch(resetTeamData()),
    };
};
const mapStateToProps = (state) => {
    return {
        trans        : state.appData.trans,
        loginResponse: state.authData.loginResponse,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(Login));


// WEBPACK FOOTER //
// ./src/components/login.js